"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      breakpoint = _useTheme.breakpoint,
      spacing = _useTheme.spacing;

  return {
    root: (0, _defineProperty2.default)({
      height: spacing(7),
      alignItems: 'center',
      display: 'none'
    }, breakpoint.up('lg'), {
      display: 'flex'
    }),
    pane: {
      margin: spacing(0, -1),
      '& > *': {
        margin: spacing(0, 1)
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ breakpoint, spacing }}", function () {
  return [_useTheme2.default];
});

var Desktop = function Desktop(props) {
  var children = props.children;
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, {
    css: classes.root,
    width: "100%",
    padding: [0, 3]
  }, (0, _core.jsx)(_Flex.default, {
    css: classes.pane,
    flex: "1 0 auto",
    justifyContent: "flex-end",
    alignItems: "center"
  }, children));
};

__signature__(Desktop, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Desktop;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Desktop/index.tsx");
  reactHotLoader.register(Desktop, "Desktop", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Desktop/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Desktop/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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